import { useCallback } from 'react';
import { IconClose } from '../../icon/IconClose';
import { Box } from '../../layout/Box';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';
import { InputTextButtonProps } from './types';

export const InputTextButton: React.FC<InputTextButtonProps> = ({
    text,
    value,
    onClick,
    ...other
}) => {
    const onIconClick = useCallback(() => {
        onClick(value);
    }, [value, onClick]);

    return (
        <Wrapper {...other} mr={1} whiteSpace="nowrap">
            <Typography variant="body2" weight="regular">
                {text}
            </Typography>
            <Box p={1} onClick={onIconClick}>
                <IconClose size={16} />
            </Box>
        </Wrapper>
    );
};
